export type SalesDeskHistoryEntry = {
  at: string;
  text: string;
};

export type SalesDeskMatchRow = {
  id: string;
  model: string;
  createdAt: string;
};

const DAY_MS = 24 * 60 * 60 * 1000;

export function salesDeskRecordDate(iso: string): string {
  const trimmed = iso.trim();
  if (!trimmed) return "";
  return trimmed.slice(0, 10);
}

export function salesDeskRecordHistory(
  createdAt: string,
  updatedAt: string,
  eventHint: string,
): SalesDeskHistoryEntry[] {
  const opened = salesDeskRecordDate(createdAt);
  const updated = salesDeskRecordDate(updatedAt) || opened;
  const rows: SalesDeskHistoryEntry[] = [];
  if (opened) rows.push({ at: opened, text: "Sale opened" });
  if (eventHint === "customer_order_submitted") rows.push({ at: updated, text: "Submitted" });
  if (eventHint === "customer_order_delivered") rows.push({ at: updated, text: "Delivered" });
  return rows.reverse();
}

export function salesDeskHandoffEntry(action: "correction" | "approve", at: string): SalesDeskHistoryEntry {
  return {
    at,
    text:
      action === "correction"
        ? "Correction requested. The administrator reviews it outside this desk."
        : "Marked for approval. The administrator still decides outside this desk.",
  };
}

export function salesDeskSameModelSales<T extends SalesDeskMatchRow>(
  sales: T[],
  sourceId: string,
  model: string,
  windowDays: number,
  nowMs: number,
): T[] {
  const key = model.trim().toLowerCase();
  if (!key || windowDays <= 0 || !/\d{1,2}\s*x\s*\d{1,2}/i.test(key)) return [];
  return sales.filter((sale) => {
    if (sale.id === sourceId) return false;
    if (sale.model.trim().toLowerCase() !== key) return false;
    const created = Date.parse(sale.createdAt);
    if (!Number.isFinite(created) || created > nowMs) return false;
    return nowMs - created <= windowDays * DAY_MS;
  });
}
